/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-07 17:01:24
 * @LastEditTime: 2025-03-24 11:53:08
 * @LastEditors: Please set LastEditors
 */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '@/redux/hooks';
import cartIcon from './imgs/cart-full.svg'
import service from './imgs/service.svg'
import arrow from './imgs/arrow.svg'
import './index.scss'
import  useBackToTop  from '@/hooks/useBackToTop';
import { openCustomerService} from '@/utils/index'
const ToolBar: React.FC = () => {
  const navigate = useNavigate();
  const { isVisible, scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const { cartCount } = useAppSelector(state => state.user);
  const handleService =()=>{
    openCustomerService();
  }
  return (
    <div className='tool-bar-container'>
      <div className="tool-bar-each" onClick={()=>navigate('user/cart')}>
        <img src={cartIcon} alt='cart' />
        <p>购物车<i>{cartCount}</i></p>
      </div>
      <div className="tool-bar-each" onClick={handleService}>
        <img src={service} alt='cart' />
        <p >人工客服</p>
      </div>
      {isVisible && <div className="tool-bar-each" onClick={scrollToTop}>
        <img src={arrow} alt='cart' />
        <p>返回顶部</p>
      </div>}
    </div>
  )
}

export default ToolBar;